<template>
  <div class="page">
    <navigation class="nav">活动规则</navigation>
    <div class="container">
      <div class="content">
        <div class="section">
          <div class="title">活动时间：{{ new Date() | formateDate('YYYY年MM月DD日') }}</div>
        </div>
        <div class="section">
          <div class="title">活动对象</div>
          <div class="desc">天美贷平台指定优质用户</div>
        </div>
        <div class="section">
          <div class="title">活动方式</div>
          <div class="desc">1、活动期间，用户集齐5色宝石，即可兑换提现高通卡1张，使用提现高通卡提现，提现通过率高达99.8%</div>
          <div class="desc">2、高通卡的领取和使用仅限活动当天有效，1张提现高通卡仅能享受1次提现高通过率特权</div>
        </div>

        <div class="section">
          <div class="title">领取使用方式</div>
          <div class="desc">活动期间，通过首页活动入口进入活动详情页，参与集5色宝石活动，并前往我要提现页面进行使用，指定时间内平台将自动为您分配高通过率资方</div>
        </div>
      </div>
      <div class="footer">活动所有解释权归天美贷所有</div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'ActOneRules',
  mounted () {
    // todo: 活动时间取值？
    this.$bus.$emit('ready')
  }
}
</script>

<style lang="less" scoped>
@import "../../../../assets/less/mixin.less";

.page {
  background: linear-gradient( 180deg, #FF641F 0%, #FFE7BC 56%, #FFF6DC 100%);
  width: 100%;
  min-height: 100vh;
  .container {
    display: flex;
    flex-direction: column;
    justify-content: flex-start;
    align-items: center;
    padding: 40px;
    .content {
      width: 670px;
      height: 1240px;
      border-radius: 30px;
      background-color: white;
      padding: 60px 30px;
      .section {
        margin-bottom: 60px;
        .title {
          font-family: PingFangSC, PingFang SC;
          font-weight: 500;
          font-size: 32px;
          color: #333333;
          line-height: 45px;
        }
        .desc {
          font-family: PingFangSC, PingFang SC;
          font-weight: 400;
          font-size: 26px;
          color: #666666;
          line-height: 37px;
        }
      }
    }
    .footer {
      text-align: center;
      font-family: PingFangSC, PingFang SC;
      font-weight: 400;
      font-size: 24px;
      color: #999999;
      line-height: 33px;
      margin-top: 50px;
    }
  }
}
</style>